/* ==========================================================================
   brand-nav.js — Fazal Shawl
   Added by customization; NOT part of the Shopfinity vendor theme.

   Opens the desktop dropdowns on hover, matching shawlsbyaima.com, whose
   menus reveal on hover with a ~0.3s fade.

   The theme renders each top-level item as
     <header-menu><details><summary>…</summary><ul class="header__submenu">
   and <details> is click-only by nature, so hover needs script. We toggle
   the native `open` property rather than adding classes, so the theme's own
   <header-menu> element keeps handling Escape, outside-click and focus
   management exactly as before.

   NOTE (2026-10-09): a card-swatch handler briefly lived here, on the belief
   that the theme never registered <card-variant-selects>. It does — lazily,
   from quick-add.js, which only loads when a section has quick add enabled.
   Card swatches therefore need `enable_quick_add: true` on that section, not
   custom script. Removed rather than left dormant.

   Guards:
     - desktop width only (the theme's own breakpoint is 990px)
     - real hover pointers only, so touch devices keep tap-to-open
     - keyboard Enter/Space on the summary still toggles normally; only
       genuine pointer clicks are suppressed, to stop click fighting hover
   ========================================================================== */
(function () {
  'use strict';

  var QUERY = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  var CLOSE_DELAY = 140; // ms of grace when travelling from label to panel
  var mql = window.matchMedia(QUERY);
  var bound = false;
  var timers = new WeakMap();

  function menus() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.header__inline-menu header-menu > details')
    );
  }

  function closeOthers(current) {
    menus().forEach(function (d) {
      if (d !== current && d.open) d.open = false;
    });
  }

  function open(details) {
    clearTimeout(timers.get(details));
    if (!mql.matches) return;
    closeOthers(details);
    if (!details.open) details.open = true;
  }

  function scheduleClose(details) {
    clearTimeout(timers.get(details));
    timers.set(details, setTimeout(function () {
      if (mql.matches && details.open) details.open = false;
    }, CLOSE_DELAY));
  }

  function onEnter(e) {
    var d = e.currentTarget;
    if (mql.matches) open(d);
  }

  function onLeave(e) {
    var d = e.currentTarget;
    if (mql.matches) scheduleClose(d);
  }

  /* A real pointer click would toggle the details shut while the cursor is
     still inside it, and hover would immediately reopen it — a flicker. Only
     suppress clicks that came from a pointer: a keyboard-generated click has
     detail === 0, so Enter and Space keep working. */
  function onSummaryClick(e) {
    if (!mql.matches) return;
    if (e.detail === 0) return;
    e.preventDefault();
  }

  function bind() {
    if (bound) return;
    menus().forEach(function (d) {
      d.addEventListener('mouseenter', onEnter);
      d.addEventListener('mouseleave', onLeave);
      var s = d.querySelector('summary');
      if (s) s.addEventListener('click', onSummaryClick);
    });
    bound = true;
  }

  function closeAll() {
    menus().forEach(function (d) {
      clearTimeout(timers.get(d));
      if (d.open) d.open = false;
    });
  }

  function init() {
    bind();
    // Leaving desktop (or rotating to a touch device) must not strand a panel open.
    var onChange = function () { if (!mql.matches) closeAll(); };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
